import {useCallback, useContext, useEffect, useState} from "react";
import {useWallet} from "use-wallet";
import {Farm} from "../contexts/Farms/types";
import BigNumber from "bignumber.js";
import {AllData} from "./stake_card_hook";
import {Context as FarmsContext} from "../contexts/Farms";

import quantile from '@stdlib/stats/base/dists/beta/quantile';

export function LoopHook(farm: Farm): LoopHookProps {

    // const model: LoopHookProps = {};

    const {lpContract, sC} = farm;
    const sCaddress = sC.options.address;
    const [model, setModel] = useState<LoopHookProps>({
        allowance: undefined,
        apy: new BigNumber(0),
        averageRrturns: undefined,
        earning: undefined,
        rewardRate: undefined,
        tokenBalance: undefined,
        totalSupply: new BigNumber(0),
        premium: 0
    });
    const {account} = useWallet();
    const {blockNumber} = useContext(FarmsContext);

    const fetchAllowance = useCallback(async () => {
        const allowance = await lpContract.methods.allowance(account, sCaddress).call();
        const allData = await sC.methods.allValues(account).call();

        const rewardRate = allData[AllData.rewardRate];
        const tokenBalance = allData[AllData.balanceOf];
        let totalSupply = allData[AllData.totalSupply];
        const earnings = allData[AllData.reward];
        let apy = new BigNumber(0);
        if (totalSupply != 0 && rewardRate != 0) {
            apy = new BigNumber(totalSupply > 0 ? rewardRate * 365 * 24 * 60 * 60 / totalSupply * 100 : 0);
        }
        const isPause: boolean = allData[AllData.isPause];
        let _premium = farm.tsl * quantile(.95, farm.tsl * 0.0001 * farm.raf, totalSupply * 4 / 1e18 * 0.0003);
        if (!_premium) _premium = 0;
        setModel({
            allowance: allowance,
            apy: apy,
            // averageRrturns: averageRrturns,
            earning: earnings,
            rewardRate: rewardRate,
            tokenBalance: new BigNumber(tokenBalance),
            totalSupply: new BigNumber(totalSupply),
            isPause: isPause,
            premium: _premium
        });
        setFarmModel(farm, {
            allowance: allowance,
            apy: apy,
            // averageRrturns: averageRrturns,
            earning: earnings,
            rewardRate: rewardRate,
            tokenBalance: new BigNumber(tokenBalance),
            totalSupply: new BigNumber(totalSupply),
            isPause: isPause,
            premium: _premium

        });


    }, [account, sCaddress, lpContract, sC, setModel, model, farm]);


    useEffect(() => {
        if (account && sCaddress && lpContract) {
            try {
                fetchAllowance();
            } catch (e) {
                console.log(e);
            }
        }
    }, [blockNumber]);

    return model;
}


export function setFarmModel(farm: Farm, model: LoopHookProps,) {
    farm.isPause = model.isPause;
    farm.tokenBalance = model.tokenBalance;
    farm.premium = model.premium;

}

interface LoopHookProps {
    tokenBalance: BigNumber, // user stake
    apy: BigNumber, // apy
    earning: number, // user earning
    averageRrturns?: number, //
    allowance: number,
    totalSupply: BigNumber,
    rewardRate: number,
    isPause?: boolean,
    premium?: number,

}
